import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export default class Products {
  constructor() {
    this.init();
    this.initFilters();
  }

  init() {
    const sliderEl = document.querySelector(".js-products-slider");
    if (!sliderEl) return;

    new Swiper(".js-products-slider", {
      modules: [Navigation, Pagination],
      slidesPerView: 3,
      spaceBetween: 20,
      navigation: {
        nextEl: ".js-products-next",
        prevEl: ".js-products-prev",
      },
      pagination: { el: ".js-products-pagination", clickable: true },
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 14 },
        640: { slidesPerView: 2, spaceBetween: 16 },
        1024: { slidesPerView: 3, spaceBetween: 20 },
      },
      observer: true,
      observeParents: true,
    });
  }

  initFilters() {
    const form = document.querySelector('.products-filter');
    if (form) {
      form.addEventListener('submit', function () {
        const inputs = form.querySelectorAll('input[name]');
        inputs.forEach(input => {
          if (input.type === 'radio' && !input.checked) {
            input.disabled = true;
          } else if (input.value.trim() === '') {
            input.disabled = true;
          }
        });
      });
    }
  }
}
